import FundReconciliation from './fund_reconciliation.vue'

export default {
    path: 'fundReconciliation',
    component: FundReconciliation
}
